/* -----------------------------------------
   Open Partners – VAT Relief Logic (Horizon, full build with tooltip)
   ----------------------------------------- */

   window.opLog = (...args) => {
  console.log("%c[VAT]", "color:#0a0", ...args);
};

console.log("✅ op-vat.js loaded");
document.body.dataset.vatScript = "loaded";

function initVatReliefLogic() {
  console.log("🚀 VAT logic initialised");

  const jsonEl = document.getElementById("op-product-json");
  const ui = document.querySelector(".op-vat-ui");
  const vatSelect = document.getElementById("op_vat_reason");
  const vatStatusInput = document.getElementById("op_vat_status");
  const notice = document.querySelector(".op-notice");
  const form = document.querySelector('form[action="/cart/add"]');

  if (!jsonEl || !ui || !form) {
    console.warn("❌ Missing VAT UI, form or JSON – exiting initVatReliefLogic");
    return;
  }

  const product = JSON.parse(jsonEl.textContent);
  const conditions = ui.querySelector(".op-vat-conditions");

  const names = product.options.map((n) => (n || "").toLowerCase().trim());
  let idx = names.findIndex((n) => n.includes("vat relief"));
  if (idx === -1) idx = names.indexOf("vat status");
  if (idx === -1) {
    console.warn("⚠️ No VAT option found in product.options");
    return;
  }

  const money = (c) => "£" + (c / 100).toFixed(2);
  const getVariantById = (id) => product.variants.find((v) => v.id === Number(id));

  // -----------------------------------------
  // Helper to block submission while disabled
  // -----------------------------------------
  function blockSubmit(e) {
    if (e.target.closest('button[name="add"], .shopify-payment-button__button')) {
      e.stopImmediatePropagation();
      e.preventDefault();
      console.log("🚫 Blocked add/buy click while VAT reason missing");
    }
  }

  // -----------------------------------------
  // Detect whether a VAT option is selected
  // -----------------------------------------
  function getSelectedVatValue() {
    const selected = document.querySelector(
      'input[name="options[Do you qualify for VAT relief?]"]:checked'
    );
    return selected ? selected.value.toLowerCase() : "";
  }

  // -----------------------------------------
  // Core render logic for VAT UI
  // -----------------------------------------
  function render(variantId) {
    console.log("🧭 render() called with variant ID:", variantId);

    const v = getVariantById(variantId);
    if (!v) {
      console.warn("⚠️ No variant found in JSON for ID", variantId);
      return;
    }

    console.log("🔍 Found variant:", v.title);

    const selectedValue = getSelectedVatValue();
    const variantVatValue = (v[`option${idx + 1}`] || "").toLowerCase();
    const reason = vatSelect?.value || "";

    let activeVatValue = selectedValue || variantVatValue;
    let disable = false;

    if (!activeVatValue) {
      console.log("🚫 No VAT option selected – disabling buttons");
      disable = true;
    } else if (activeVatValue.includes("yes") && !reason) {
      console.log("🧾 VAT relief selected but no reason – disabling buttons");
      disable = true;
    }

    const ex = v.price;
    const inc = Math.round(ex * 1.2);

    if (activeVatValue.includes("yes")) {
      console.log("🧾 VAT relief selected → showing dropdown");
      conditions.style.display = "";
      document.querySelector(".op-main-price").innerHTML = `
        <span class="price">${money(ex)}</span> 
        <span class="vat-msg">(VAT exempt price)</span>`;
      vatStatusInput.value = "YES";
      if (notice) notice.style.display = "";
    } else if (activeVatValue.includes("no")) {
      console.log("💰 Standard VAT applied → hiding dropdown");
      conditions.style.display = "none";
      document.querySelector(".op-main-price").innerHTML = `
        <div>
          <span class="price" style="display:inline-block;">${money(ex)}</span>
          <div class="vat-msg" style="font-size:17px; margin-top:4px; font-weight:500;">
            <strong>Total incl. VAT:</strong> ${money(inc)}
          </div>
        </div>`;
      vatStatusInput.value = "NO";
      if (vatSelect) vatSelect.value = "";
      if (notice) notice.style.display = "none";
    } else {
      conditions.style.display = "none";
    }

    if (form) {
      if (disable) {
        form.classList.add("op-vat-disabled");
        form.addEventListener("click", blockSubmit, true);
      } else {
        form.classList.remove("op-vat-disabled");
        form.removeEventListener("click", blockSubmit, true);
      }
    }

    console.log(
      `✅ VAT UI updated → disable=${disable}, reason="${reason}", activeVatValue="${activeVatValue}"`
    );

    // 🧩 Reinject tooltip after Shopify redraws variant DOM
    setTimeout(() => {
      injectVatTooltip();
      updateColourLegend(variantId);
    }, 400);
  }

  // -----------------------------------------
  // Variant detection helpers
  // -----------------------------------------
  function getCurrentVariantIdFromURL() {
    const url = new URL(window.location.href);
    const id = url.searchParams.get("variant");
    return id ? Number(id) : product?.variants?.[0]?.id;
  }

  function handleURLChange() {
    const id = getCurrentVariantIdFromURL();
    if (id) {
      console.log("🔄 URL variant change detected →", id);
      render(id);
    } else {
      console.warn("⚠️ No variant found in URL");
    }
  }

  // -----------------------------------------
  // Update colour legend span
  // -----------------------------------------
  function updateColourLegend(variantId) {
    const colourFieldset = document.querySelector('fieldset[data-option-id*="colour"]');
    if (!colourFieldset) return;

    const legend = colourFieldset.querySelector('legend');
    if (!legend) return;

    const span = legend.querySelector('.selected-colour');
    const variant = getVariantById(variantId);
    if (!variant) return;

    const optionNames = product.options.map((n) => (n || '').toLowerCase().trim());
    const colourIdx = optionNames.findIndex((n) => n.includes('colour'));
    if (colourIdx === -1) return;

    const currentColour = variant[`option${colourIdx + 1}`];

    if (span) {
      span.textContent = ` – ${currentColour}`;
    } else {
      const newSpan = document.createElement('span');
      newSpan.className = 'selected-colour';
      newSpan.textContent = ` – ${currentColour}`;
      legend.appendChild(newSpan);
    }

    console.log(`🎨 Colour legend updated → ${currentColour}`);
  }

  // 🧩 Tooltip injector
  function injectVatTooltip() {
    const vatLegend = document.querySelector(
      '[data-option-id*="do-you-qualify-for-vat-relief"] legend'
    );

    if (!vatLegend || vatLegend.querySelector(".op-info-btn")) return;

    vatLegend.classList.add("op-vat-legend");

    const infoBtn = document.createElement("button");
infoBtn.type = "button";
infoBtn.className = "op-info-btn";
infoBtn.setAttribute("aria-label", "Learn more about VAT relief");

// Replace text with SVG
infoBtn.innerHTML = `
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M9 15H11V9H9V15ZM10 7C10.2833 7 10.521 6.904 10.713 6.712C10.905 6.52 11.0007 6.28267 11 6C10.9993 5.71733 10.9033 5.48 10.712 5.288C10.5207 5.096 10.2833 5 10 5C9.71667 5 9.47933 5.096 9.288 5.288C9.09667 5.48 9.00067 5.71733 9 6C8.99933 6.28267 9.09533 6.52033 9.288 6.713C9.48067 6.90567 9.718 7.00133 10 7ZM10 20C8.61667 20 7.31667 19.7373 6.1 19.212C4.88334 18.6867 3.825 17.9743 2.925 17.075C2.025 16.1757 1.31267 15.1173 0.788001 13.9C0.263335 12.6827 0.000667933 11.3827 1.26582e-06 10C-0.000665401 8.61733 0.262001 7.31733 0.788001 6.1C1.314 4.88267 2.02633 3.82433 2.925 2.925C3.82367 2.02567 4.882 1.31333 6.1 0.788C7.318 0.262667 8.618 0 10 0C11.382 0 12.682 0.262667 13.9 0.788C15.118 1.31333 16.1763 2.02567 17.075 2.925C17.9737 3.82433 18.6863 4.88267 19.213 6.1C19.7397 7.31733 20.002 8.61733 20 10C19.998 11.3827 19.7353 12.6827 19.212 13.9C18.6887 15.1173 17.9763 16.1757 17.075 17.075C16.1737 17.9743 15.1153 18.687 13.9 19.213C12.6847 19.739 11.3847 20.0013 10 20ZM10 18C12.2333 18 14.125 17.225 15.675 15.675C17.225 14.125 18 12.2333 18 10C18 7.76667 17.225 5.875 15.675 4.325C14.125 2.775 12.2333 2 10 2C7.76667 2 5.875 2.775 4.325 4.325C2.775 5.875 2 7.76667 2 10C2 12.2333 2.775 14.125 4.325 15.675C5.875 17.225 7.76667 18 10 18Z" fill="#525252"/>
  </svg>
`;


    const tooltip = document.createElement("div");
    tooltip.className = "op-tooltip";
    tooltip.setAttribute("role", "tooltip");

    tooltip.innerHTML = `
      <button type="button" class="op-tooltip-close" aria-label="Close tooltip">×</button>
      <p>
        VAT relief allows eligible customers to purchase certain products without paying VAT.
        You must have a qualifying medical condition or disability.
      </p>
    `;

    vatLegend.appendChild(infoBtn);
    vatLegend.appendChild(tooltip);

    infoBtn.addEventListener("click", (e) => {
      e.stopPropagation();
      tooltip.classList.toggle("active");
    });

    tooltip.querySelector(".op-tooltip-close").addEventListener("click", (e) => {
      e.stopPropagation();
      tooltip.classList.remove("active");
    });

    document.addEventListener("click", (e) => {
      if (!tooltip.contains(e.target) && !infoBtn.contains(e.target)) {
        tooltip.classList.remove("active");
      }
    });

    console.log("ℹ️ VAT tooltip injected");
  }

  // Listen for pushState / popState events
  const _pushState = history.pushState;
  history.pushState = function () {
    _pushState.apply(this, arguments);
    handleURLChange();
  };
  window.addEventListener("popstate", handleURLChange);

  // Watch radio inputs
  const radios = document.querySelectorAll(
    '.variant-picker__form input[type="radio"][data-variant-id]'
  );
  radios.forEach((radio) => {
    radio.addEventListener("change", (e) => {
      console.log("🔘 radio changed →", e.target.value, e.target.dataset.variantId);
      render(e.target.dataset.variantId);
    });
  });

  // Watch VAT dropdown changes
  vatSelect?.addEventListener("change", () => {
    console.log("📑 VAT dropdown changed →", vatSelect.value);
    handleURLChange();
  });

  // Prevent submission when VAT reason missing
  form.addEventListener("submit", (e) => {
    const id = getCurrentVariantIdFromURL();
    const v = getVariantById(id);
    const variantVatValue = (v && v[`option${idx + 1}`] || "").toLowerCase();
    const selectedValue = getSelectedVatValue();
    const activeVatValue = selectedValue || variantVatValue;
    const reason = vatSelect?.value || "";

    if (!activeVatValue) {
      e.preventDefault();
      alert("Please select whether you qualify for VAT relief before continuing.");
      console.log("🚫 Form submission blocked – no VAT selection");
    } else if (activeVatValue.includes("yes") && !reason) {
      e.preventDefault();
      alert("Please select a medical condition before continuing.");
      console.log("🚫 Form submission blocked – missing VAT reason");
    }
  });

  console.log("🏁 Initialising VAT UI...");
  injectVatTooltip();
  handleURLChange();
}

// Run on first load
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initVatReliefLogic);
} else {
  initVatReliefLogic();
}

// Run again whenever Shopify re-renders product info
document.addEventListener("shopify:section:load", (e) => {
  if (e.target.querySelector('[data-testid="product-information-details"]')) {
    console.log("♻️ Shopify section reload detected");
    initVatReliefLogic();
  }
});
